// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"210":"1456a5cf","650":"593403cd"}[chunkId] + ".chunk.js";
};